import React, { useState, useEffect } from 'react';
import { Select, Spin } from 'antd';
import api from '../utils/axios';

const { Option } = Select;

const DepartmentSelect = ({ 
  value, 
  onChange, 
  placeholder = "请选择部门", 
  allowClear = true,
  style = { width: '100%' },
  ...props 
}) => {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchDepartments();
  }, []);

  const fetchDepartments = async () => {
    setLoading(true);
    try {
      console.log('🔍 获取部门列表...');
      const response = await api.get('/departments');
      console.log('✅ 获取部门列表成功:', response.data);
      if (response.data.success) {
        setDepartments(response.data.data || []);
      } else {
        setDepartments([]);
      }
    } catch (error) {
      console.error('❌ 获取部门列表失败:', error);
      setDepartments([]);
    } finally {
      setLoading(false);
    }
  };

  console.log('🎯 DepartmentSelect 渲染状态:', { 
    departments: departments.length, 
    loading, 
    value,
    placeholder 
  });

  return (
    <Select
      value={value !== null ? value : undefined}
      onChange={onChange}
      placeholder={placeholder}
      allowClear={allowClear}
      style={style}
      loading={loading}
      notFoundContent={loading ? <Spin size="small" /> : null}
      showSearch
      optionFilterProp="children"
      getPopupContainer={(triggerNode) => triggerNode.parentNode}
      {...props}
    >
      {departments.map(dept => (
        <Option key={dept.id} value={dept.id}>
          {dept.name} ({dept.code})
        </Option>
      ))}
    </Select>
  );
};

export default DepartmentSelect; 